import { render } from "./InformacionEconomica.vue?vue&type=template&id=704a3f77&scoped=true"
import script from "./InformacionEconomica.vue?vue&type=script&lang=js"
export * from "./InformacionEconomica.vue?vue&type=script&lang=js"

import "./InformacionEconomica.vue?vue&type=style&index=0&id=704a3f77&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704a3f77"]])

export default __exports__